import { dataService } from 'App';
import { FORM_URL_ENCODED_HEADERS_CONF, FORM_MULTI_HEADERS_CONF} from 'utils/requestHelpers';


const alphanumericUrlStart = '/users/alphanumerics';
const signupUrlStart = '/users/signup';

/**
 *
 * @param {object} data info about user
 * @return {object} otp of users / error
 */
export function getAlphaNumerics() {
  return dataService.get(`${alphanumericUrlStart}`);
}


export function getActiveAlphaNumerics() {
  return dataService.get(`${alphanumericUrlStart}/active`);
}

export function deleteAlphaNumeric(data) {
  var postData = 'id=' + data.id;
  return dataService.delete(`${alphanumericUrlStart}/${data.alphaNumericId}`, postData, FORM_URL_ENCODED_HEADERS_CONF);
}

export function corporateGetFirmDetails(data) {
  return dataService.get(
    `${data.signupUrlStart}/firms/${data.firmId}`
  );
}

export function corporateGetFirms(data) {
  return dataService.get(`${signupUrlStart}/firms`);
}

export function corporateGetFirm() {
  return dataService.get(`${signupUrlStart}/firm`);
}

export function checkOnMaya(data) {
  var postData = 'vergiNo=' + data.vergiNo;
  return dataService.delete(`${signupUrlStart}/customerquery`,  postData,FORM_URL_ENCODED_HEADERS_CONF
  );
}

export function validateAlpha(data) {
  var postData = 'customAlphanumeric=' + data.alpha;
  return dataService.post(`${signupUrlStart}/validate`,  postData, FORM_URL_ENCODED_HEADERS_CONF);
}


export function checkMernis(data) {
const searchParams = new URLSearchParams();
for (const prop in data) {
  searchParams.set(prop, data[prop]);
}


  return dataService.post(`${signupUrlStart}/mernis`, searchParams, FORM_URL_ENCODED_HEADERS_CONF);
}

export function createNewFirm(data) {
  let form = new FormData();
  form.append("additionalFile", data.additionalFile);
  form.append("commercialFile", data.commercialFile);
  form.append("taxFile", data.taxFile);
  form.append("alphaNumeric", data.title);
  form.append("brandCode", data.brandCode);
  form.append("kurumAdi", data.kurumAdi);
  form.append("name", data.name);
  form.append("surname", data.surname);
  form.append("tckNo", data.tckNo);
  form.append("vergiDairesi", data.vergiDairesi);
  form.append("vergiNo", data.vergiNo);
  form.append("cuzdanSeriNo", data.cuzdanSeriNo);
  form.append("dogumTarihi", data.dogumTarihi);
  form.append("email", data.email);
  return dataService.post(`${signupUrlStart}`,  form, FORM_MULTI_HEADERS_CONF);
}

export function createNewAlphaNumeric(data) {
  let form = new FormData();
  form.append("additionalFile", data.additionalFile);
  form.append("alphaNumeric", data.title);
  form.append("brandCode", data.brandCode);
  return dataService.post(`${signupUrlStart}/newAlphaNumeric`,  form, FORM_MULTI_HEADERS_CONF);
}


export function updateBrandCode(data) {
  const searchParams = new URLSearchParams();
  for (const prop in data) {
    searchParams.set(prop, data[prop]);
  }
  
  
    return dataService.post(`${signupUrlStart}/alphanumeric/updateBrandCode`, searchParams, FORM_URL_ENCODED_HEADERS_CONF);
}